import { Component, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-age-picker-dialog',
  templateUrl: './age-picker-dialog.component.html',
  styleUrl: './age-picker-dialog.component.scss'
})
export class AgePickerDialogComponent {
  readonly dialogRef = inject(MatDialogRef<AgePickerDialogComponent>);
  readonly fb = inject(FormBuilder);

  agePickerForm = this.fb.group({
    birthday: this.fb.nonNullable.control<Date | undefined>(undefined),
  })

  futureFilter = (d: Date | null): boolean => {
    return d! < new Date();
  };

  public isDate18orMoreYearsOld(date?: Date) {
    if (!date) return false;

    var limit = new Date();
    limit.setFullYear(limit.getFullYear()-18);
    return date <= limit;
  }
}
